export function createPosCategoryNavigation() {
    let root;
    let header;
    let sectionsContainer;
    let resizeObserver;
    let mutationObserver;
    let frame;
    let component;
    const gap = 16;

    const sections = () => [...root.querySelectorAll('[data-pos-category]')];

    const revealCurrentLink = () => {
        const link = [
            ...root.querySelectorAll('[data-pos-category-link]'),
        ].find(
            (candidate) =>
                candidate.dataset.posCategoryLink === component.activeCategory,
        );
        const nav = root.querySelector('[data-pos-category-nav]');
        if (!link || !nav) {
            return;
        }

        const bounds = link.getBoundingClientRect();
        const viewport = nav.getBoundingClientRect();
        if (bounds.left < viewport.left || bounds.right > viewport.right) {
            nav.scrollBy({
                left:
                    bounds.left -
                    viewport.left -
                    (nav.clientWidth - bounds.width) / 2,
                behavior: 'instant',
            });
        }
    };

    const updateCategory = () => {
        if (root.clientHeight === 0) {
            return;
        }

        const categories = sections();
        const line = header.getBoundingClientRect().bottom + gap + 1;
        let current = categories[0];
        for (const section of categories) {
            if (section.getBoundingClientRect().top > line) {
                break;
            }
            current = section;
        }

        component.activeCategory = current?.dataset.posCategory ?? null;
        revealCurrentLink();
    };

    const measure = () => {
        if (root.clientHeight === 0) {
            return;
        }

        const offset = header.getBoundingClientRect().height + gap;
        const last = sections().at(-1);
        // A short final category still needs enough scroll range to reveal its title.
        sectionsContainer.style.paddingBottom = `${last ? Math.max(0, root.clientHeight - offset - last.offsetHeight) : 0}px`;
    };

    const schedule = () => {
        if (frame !== undefined) {
            return;
        }

        frame = requestAnimationFrame(() => {
            frame = undefined;
            measure();
            updateCategory();
        });
    };

    return {
        activeCategory: null,
        init() {
            component = this;
            root = this.$el;
            header = root.querySelector('[data-pos-category-header]');
            sectionsContainer = root.querySelector(
                '[data-pos-category-sections]',
            );
            root.addEventListener('scroll', schedule, { passive: true });
            resizeObserver = new ResizeObserver(schedule);
            resizeObserver.observe(root);
            resizeObserver.observe(header);
            resizeObserver.observe(sectionsContainer);
            mutationObserver = new MutationObserver(schedule);
            mutationObserver.observe(root, { childList: true, subtree: true });
            measure();
            updateCategory();
        },
        goToCategory(event, categoryId) {
            if (
                event.button !== 0 ||
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey
            ) {
                return;
            }

            const section = sections().find(
                (candidate) => candidate.dataset.posCategory === categoryId,
            );
            if (!section) {
                return;
            }

            event.preventDefault();
            measure();
            root.scrollBy({
                top:
                    section.getBoundingClientRect().top -
                    header.getBoundingClientRect().bottom -
                    gap,
                behavior: 'instant',
            });
            updateCategory();
        },
        destroy() {
            root.removeEventListener('scroll', schedule);
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            if (frame !== undefined) {
                cancelAnimationFrame(frame);
            }
        },
    };
}
